import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { DashboardPage } from '@/components/Dashboard/DashboardPage'
import {
  dashboardSearchSchema,
  EMPTY_DASHBOARD_SEARCH,
  withoutDashboardDefaults,
  type DashboardSearch,
} from '@/components/Dashboard/dashboardSearch'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only. The schema lives beside the page in `dashboardSearch.ts`. */
export const Route = createFileRoute('/_app/')({
  validateSearch: dashboardSearchSchema,
  search: { middlewares: [stripSearchParams(EMPTY_DASHBOARD_SEARCH)] },
  component: DashboardRoute,
})

function DashboardRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<DashboardSearch>) =>
      void navigate(
        inPageSearch(withoutDashboardDefaults, next, {
          // Opening a card's help panel is a new view the back button closes.
          push: next.about !== undefined,
        }),
      ),
    [navigate],
  )
  return <DashboardPage search={search} onSearchChange={onSearchChange} />
}
